// src/components/myteconstruction/ForemanCRM.js

import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../../../context/AuthContext';
import { Trash2 } from 'lucide-react';

export default function ForemanCRM() {
  const { auth } = useContext(AuthContext);
  const [foremen, setForemen] = useState([]);
  const [statusMessage, setStatusMessage] = useState('');

  // Fetch foremen list on mount
  useEffect(() => {
    axios
      .get('/api/myteconstruction/foremen', {
        headers: { Authorization: `Bearer ${auth.token}` },
      })
      .then((res) => setForemen(res.data.foremen))
      .catch((err) => {
        console.error('Error fetching foremen:', err);
        setStatusMessage('Failed to fetch foremen.');
      });
  }, [auth.token]);

  const handleRemove = async (foremanId) => {
    if (!window.confirm('Are you sure you want to remove this foreman?')) return;
    try {
      await axios.delete(`/api/myteconstruction/foremen/${foremanId}`, {
        headers: { Authorization: `Bearer ${auth.token}` },
      });
      setStatusMessage('Foreman removed successfully.');
      setForemen((prev) => prev.filter((f) => f._id !== foremanId));
    } catch (err) {
      console.error('Error removing foreman:', err);
      setStatusMessage('Failed to remove foreman.');
    }
  };

  return (
    <div className="p-4 bg-gray-900 rounded-lg">
      <h2 className="text-xl font-semibold text-white mb-4">Foremen List</h2>
      {statusMessage && (
        <div className="mb-4 text-sm text-blue-300">{statusMessage}</div>
      )}
      <table className="w-full text-left text-gray-400">
        <thead>
          <tr>
            <th>Email</th>
            <th>Status</th>
            <th>Invited At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {foremen.map((foreman) => (
            <tr key={foreman._id}>
              <td>{foreman.email}</td>
              <td>{foreman.invitationStatus}</td>
              <td>{new Date(foreman.invitedAt).toLocaleDateString()}</td>
              <td>
                <button
                  onClick={() => handleRemove(foreman._id)}
                  className="bg-red-600 hover:bg-red-700 transition-colors duration-200 px-3 py-1 rounded-lg flex items-center gap-1"
                  title="Remove foreman"
                >
                  <Trash2 className="h-4 w-4" />
                  <span className="hidden sm:inline">Remove</span>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
